import { ControlContainer, NgForm }               from '@angular/forms';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerNavigateEvent,
  NgbDateStruct
} from '@ng-bootstrap/ng-bootstrap';

import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

import { DateAdapter }          from './date.adapter';
import { DateParserFormatter }  from './date.parser';
import { DateService }          from './date.service';
import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  selector   : 'wor-date-control',
  template: require('./date-control.component.html'),

  providers: [
    {
      provide : NgbDateAdapter,
      useClass: DateAdapter
    },
    {
      provide : NgbDateParserFormatter,
      useClass: DateParserFormatter
    }
  ],

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class DateControlComponent extends TextControlComponent implements OnInit {
  @Input() icon         = 'calendar';
  @Input() iconTheme    = 'workshop';
  // which days the calendar greys out, as ng-bootstrap asks: the day and the month on show
  @Input() markDisabled : ( date : NgbDateStruct, current : { month : number; year : number } ) => boolean;
  // how the calendar moves between months: select, arrows or none, as ng-bootstrap names them
  @Input() navigation   : 'select' | 'arrows' | 'none' = 'select';

  // the month the calendar has moved to, so a caller can fetch what greys that month
  @Output() navigated : EventEmitter<NgbDatepickerNavigateEvent> = new EventEmitter<NgbDatepickerNavigateEvent>();

  _disabled: boolean;
  _required: boolean;
  yearOnly = false;

  constructor (
    private dateService: DateService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.model && !this.dateService.containsDelimiter(this.model)) {
      this.yearOnly = true;
    }
  }
};
